class InterestCalculator {
  constructor(element) {
    this.element = element;
    this.inputField = null;
    this.formElement = null;
    this.tableRowElements = [];
    this.init();
  }

  init() {
    this.bootstrap();
    this.addEventListeners();
    this.handleInterestCalculation();
  }

  bootstrap() {
    this.inputField = this.element.querySelector('input#amount');
    this.formElement = this.element.querySelector('.interest-calculator-form');
    this.tableRowElements = this.element.querySelectorAll('.result-row');
  }

  addEventListeners() {
    this.formElement.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleInterestCalculation();
    });

    this.inputField.addEventListener('input', (e) => {
      e.target.value = this.formatInputValue(e.target.value);
      this.handleInterestCalculation();
    });
  }

  formatInputValue(value) {
    value = value.replace(/[^\d]/g, '');
    const inputValue = parseInt(value, 10);
    return isNaN(inputValue) ? '' : '€ ' + inputValue.toLocaleString('nl-NL', { maximumFractionDigits: 0 });
  }

  calculateInterest(amount, rates, paymentsPerYear) {
    return rates.reduce((totalInterest, rate) => {
      const rateAmount = rate.maxAmount ? Math.min(amount, rate.maxAmount) : amount;
      const ratePercentage = rate.interest / 100;
      const compoundedInterest = rateAmount * Math.pow((1 + ratePercentage / paymentsPerYear), paymentsPerYear) - rateAmount;
      amount -= rateAmount;
      return totalInterest + compoundedInterest;
    }, 0);
  }

  handleInterestCalculation() {
    const amount = parseInt(this.inputField.value.replace(/[^\d]/g, ''), 10);

    this.tableRowElements.forEach(row => {
      const rates = JSON.parse(row.getAttribute('data-interest-rates'));
      const paymentsPerYear = parseInt(row.getAttribute('data-payments'), 10);

      const oneYearInterest = this.calculateInterest(amount, rates, paymentsPerYear);
      const fiveYearInterest = this.calculateCompoundInterest(amount, rates, paymentsPerYear, 5);

      row.querySelector('.one-year').textContent = this.formatCurrency(oneYearInterest);
      row.querySelector('.five-year').textContent = this.formatCurrency(fiveYearInterest);
    });
  }

  calculateCompoundInterest(amount, rates, paymentsPerYear, years) {
    let totalInterest = 0;
    let compoundingAmount = amount;

    for (let i = 0; i < years; i++) {
      const interest = this.calculateInterest(compoundingAmount, rates, paymentsPerYear);
      compoundingAmount += interest;
      totalInterest += interest;
    }

    return totalInterest;
  }

  formatCurrency(value) {
    return isNaN(value) ? '€ 0,-' : '€ ' + value.toLocaleString('nl-NL', { maximumFractionDigits: 0 }) + ',-';
  }
}

// Initialize the InterestCalculator

export function registerInterestCalculators() {
  document.querySelectorAll('.interest-calculator').forEach((el) => {
    if (el.classList.contains('strapped')) {
      return;
    }
    new InterestCalculator(el);
    el.classList.add('strapped');
  });
}
